import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import successImg from '../../../assets/images/logo_2.png'
import Button from '../../../components/Button'
import { COUNTRY } from '../../../const/constants'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import { procedureComplete } from '../../../redux/actions'

const PortabilidadSuccess = () => {
  const { setBlockNavigation, settings }: any = useAppContext()
  const history = useHistory()

  const activatedLineNumber = useSelector((state: any) => state.activatedLineNumber)

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onContinue = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/portabilidades')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <div className="landing-container">
        {settings.country === COUNTRY.PY ? (
          <div className="ion-padding-horizontal">
            <img src={successImg} alt="finished portability" style={{ height: '150px' }} />
            <h3 id="new-portability-started">
              <strong>
                El proceso de <br /> portabilidad ya inició
              </strong>
            </h3>
            <p className="recommendations">
              El número de línea provisorio es <br />
              <strong>{activatedLineNumber}</strong>
            </p>
            <p className="recommendations">
              El cliente recibirá un SMS a su chip actual avisándole a partir de cuando puede colocar el chip Claro.
            </p>
          </div>
        ) : (
          <div className="ion-padding-horizontal">
            <h3 id="new-portability-success">
              <strong>
                ¡Felicitaciones! <br />
                Tu proceso de portabilidad ya se inició
              </strong>
            </h3>
            <br />
            <p className="recommendations">
              Te va a llegar un <strong>SMS</strong> a tu chip actual avisándote a partir de cuándo podés colocar el
              chip Claro.
            </p>
            <p className="recommendations">
              Toda esta información te llegará al mail junto con el detalle de tu nuevo Plan.
            </p>
          </div>
        )}
        <Button
          id="portability-success-back-to-start"
          className="link-button"
          landing
          label="Ir al inicio"
          handleSubmit={onContinue}
        />
      </div>
    </main>
  )
}

export default PortabilidadSuccess
